module.exports = __webpack_public_path__ + "images/7f79c08.png";